<ng-container *ngIf="dataSource?.length">
  <lx-price-lists-portal-table-header title="Premium Activities" [currency]="currency"></lx-price-lists-portal-table-header>
  <lx-price-lists-portal-price-and-note-table
    [company]="company"
    [dataSource]="dataSource"
    [columnLabels]="columnLabels"
  ></lx-price-lists-portal-price-and-note-table>
  <lx-price-lists-portal-notes *ngIf="notes?.length > 0" [notes]="notes" [notationMarks]="notationMarks" [company]="company"></lx-price-lists-portal-notes>
</ng-container>
